import money from '@free2move/money';
import Vue from 'vue';
import dayjs from 'dayjs';
import App from './App.vue';
import i18n from './i18n/i18n';
import cookie from 'js-cookie'
import '@/directives';
import 'leaflet/dist/leaflet.css';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/nl';

import '@free2move/vuejs-components/vuejs-components.css';

const app = <HTMLElement> document.querySelector('#widget-contact-form');

Vue.config.productionTip = false;
Vue.prototype.$money = money;
Vue.prototype.$language = app?.dataset?.language || 'en'
Vue.prototype.$country = app?.dataset?.country || 'GB';
Vue.prototype.$baseUrl = '';
Vue.prototype.$appBaseUrl = '/cod/contact';
Vue.prototype.$dataset = app?.dataset || {};


dayjs.locale('fr');

new Vue({
    i18n,
    render: (h) => h(App),
}).$mount('#widget-contact-form');
